import { useState } from "react";
import Closed from "../component/app/closed";

export default function Calculator(props) {
  const [container] = useState(
    "bg-white w-full sm:w-1/2 lg:w-2/5 h-92vh transition-all duration-500 transform "
  );
  const [result, setResult] = useState("");
  return (
    <div
      className={
        props.open ? container + "scale-100" : container + "scale-0 hidden"
      }
    >
      <Closed name="Calculator" />
      <div className="flex flex-wrap justify-center relatife">
        <input
          type="text"
          className="p-3 mx-6 my-2 mt-5 w-full border focus:outline-none text-right"
          placeholder="0"
          value={result}
          readOnly
          onKeyUp={(e) => setResult(e.target.value)}
        />
        <div className="w-full p-3 text-right mx-6 text-gray-400">
          <p>
            {result[result.length - 1] === "+" ||
            result[result.length - 1] === "-" ||
            result[result.length - 1] === "/" ||
            result[result.length - 1] === "*" ||
            result[0] === "+" ||
            result[0] === "-" ||
            result[0] === "/" ||
            result[0] === "*" ||
            result[0] === ""
              ? "0"
              : eval(String(result))}
          </p>
        </div>
        <div className="flex absolute bottom-0 flex-wrap w-full px-4 pb-4 md:pb-16">
          {[1, 2, 3].map((d, i) => (
            <div key={i} className="p-2 w-1/4">
              <button
                key={i}
                onClick={(e) => setResult(String(result) + d)}
                className="p-2 w-full bg-gray-200 text-2xl focus:outline-none"
              >
                {d}
              </button>
            </div>
          ))}
          <div className="p-2 w-1/4">
            <button
              disabled={!String(result)}
              onClick={(e) => setResult(result + "+")}
              className="p-2 w-full bg-gray-200 text-2xl focus:outline-none"
            >
              +
            </button>
          </div>
          {[4, 5, 6].map((d, i) => (
            <div key={i} className="p-2 w-1/4">
              <button
                key={i}
                onClick={(e) => setResult(String(result) + d)}
                className="p-2 w-full bg-gray-200 text-2xl focus:outline-none"
              >
                {d}
              </button>
            </div>
          ))}
          <div className="p-2 w-1/4">
            <button
              disabled={!String(result)}
              onClick={(e) => setResult(result + "-")}
              className="p-2 w-full bg-gray-200 text-3xl w-1/4 focus:outline-none"
            >
              -
            </button>
          </div>
          {[7, 8, 9].map((d, i) => (
            <div key={i} className="p-2 w-1/4">
              <button
                key={i}
                onClick={(e) => setResult(String(result) + d)}
                className="p-2 w-full bg-gray-200 text-2xl focus:outline-none"
              >
                {d}
              </button>
            </div>
          ))}
          <div className="p-2 w-1/4">
            <button
              disabled={!String(result)}
              onClick={(e) => setResult(result + "/")}
              className="p-2 w-full bg-gray-200 text-3xl focus:outline-none"
            >
              /
            </button>
          </div>
          <div className="p-2 w-1/4">
            <button
              disabled={!String(result)}
              onClick={(e) => setResult(result + "*")}
              className="p-2 w-full bg-gray-200 text-2xl focus:outline-none"
            >
              *
            </button>
          </div>
          {[0].map((d, i) => (
            <div key={i} className="p-2 w-1/4">
              <button
                key={i}
                onClick={(e) => setResult(String(result) + d)}
                className="p-2 w-full bg-gray-200 text-2xl focus:outline-none"
              >
                {d}
              </button>
            </div>
          ))}
          <div className="p-2 w-1/4">
            <button
              disabled={!String(result)}
              onClick={(e) => setResult("")}
              className="p-2 w-full bg-gray-200 text-2xl focus:outline-none"
            >
              <i className="fas fa-trash-alt"></i>
            </button>
          </div>
          <div className="p-2 w-1/4">
            <button
              disabled={!String(result)}
              onClick={(e) =>
                setResult(String(result).slice(0, String(result).length - 1))
              }
              className="p-2 w-full bg-gray-200 text-2xl focus:outline-none"
            >
              <i className="fas fa-eraser"></i>
            </button>
          </div>
          <div className="p-2 w-1/4">
            <button
              disabled={!String(result)}
              onClick={(e) => setResult(eval(String(result)))}
              className="p-2 w-full bg-gray-200 text-2xl focus:outline-none"
            >
              =
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
